import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import * as values from '../../../values'

export const DOC = gql`
  fragment FragmentDmsIntrinsicValueType on DmsIntrinsicValueType {
    intrinsic
  }
`

export const TRANSFORMER = graphql.transformers.OUT.select<
  graphql.schema.FragmentDmsIntrinsicValueTypeFragment,
  ents.core.common.value.types.Intrinsic,
  'intrinsic'
>('intrinsic', values.enums.intrinsicValueType.TRANSFORMER)
